// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_6a711","container":"_0d04c","row":"_0b93e","content":"_16bdb"};